import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  CategoryFacetedSearchQuery,
  CategoryFacetedSearchService,
  CategoryFacetedSearchStore,
  CategoryPageViewFilterService,
  FilterQuery,
  FilterService,
  FilterStore,
} from '@lobos/library';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@ngneat/transloco';

import { CatalogRoutingModule } from './catalog-routing.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, CatalogRoutingModule, TranslocoModule],
  providers: [
    { provide: TRANSLOCO_SCOPE, useValue: 'catalog' },
    CategoryFacetedSearchQuery,
    CategoryFacetedSearchService,
    CategoryFacetedSearchStore,
    CategoryPageViewFilterService,
    FilterQuery,
    FilterStore,
    FilterService,
  ],
})
export class CatalogModule {}
